import "./style.js"

// App
import app from "./app.js"
import "./app.login.config"

// Services
import "./services/api.service"
import "./services/permission.service"
import "./services/app-routes.service"
import "./services/login.service"
import "./services/formulario.service"
import "./services/ficha-alumno.service"
import "./services/usuario.service"
import "./services/lista-atenciones.service"

// Controllers
import "./controllers/login/login.controller"
import "./controllers/videos/videos.controller"
import "./controllers/formularios"
import "./modules/ficha-alumno/components/atenciones/formularios/controllers"

// Components
import "./components/dashboard/dashboard.component"
import "./components/layout/layout.component"
import "./components/search/search.component"
import "./components/table/table.component"
import "./components/table-paginacion-local/table-paginacion-local.component"
import "./components/lista-alumnos/lista-alumnos.component"
import "./components/usuario/usuario.component"
import "./components/mantenedor/mantenedor.component"
import "./components/mantenedor-paginacion-local/mantenedor-paginacion-local.component"

// -> Atenciones
import "./components/atenciones/lista-atenciones.component"
import "./components/atenciones/formularios/controllers"
// -> Admin
import "./components/admin/admin.component"
import "./components/admin/formularios"
import "./components/ayuda/ayuda.component"
import "./components/student-profile/student-profile.component"

// import "../app/testing/enter-key-press.directive.js";
// import "../app/stats.service.js";

/* COMENTARIOS */
import "./components/comentarios/comentarios.component"
import "./components/comentarios/formularios/controllers"

// set value on window object
// to access out of this scope

// Analytics
window.TRACK_SENTRY = TRACK_SENTRY
window.TRACK_HOTJAR = TRACK_HOTJAR
window.TRACK_ANALYTICS = TRACK_ANALYTICS
window.TRACK_ID_ANALYTICS = TRACK_ID_ANALYTICS
window.TRACK_ID_HOTJAR = TRACK_ID_HOTJAR
